import { createFileRoute, redirect, Outlet } from "@tanstack/react-router";
import { store } from "@/store";

export const Route = createFileRoute("/(onboarding)")({
  beforeLoad: async () => {
    const user = store.getState().auth.currentUser;
    if (!user) {
      throw redirect({ to: "/login" });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
